import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import ButtonActionIcon from "../../../components/BuilderComponents/ButtonActionIcon";
import MaterialIcon from "../../../components/BuilderComponents/MaterialIcon";
import SuccessError from "../../StateMachine/SuccessError";
import BuilderModal from "../../../Layouts/Modal/BuilderModal";
import TableTreeModal from "../../../components/BuilderComponents/TableTreeModal";
import BuilderRightSideBar from "../../../Layouts/BuilderRightSideBar";
import OwnerAssignment from "../../StateMachine/OwnerAssignment";
import { useEntityContext } from "../../../context/EntityContext";
import axiosInstance, { handleApiError } from "../../../services/axiosService";
import { toastError } from "../../../utils/toastUtils";
import OwnerAssignmentCard from "../../StateMachine/OwnerAssignmentCard";

const EntitySettings = ({ allFieldsObject }) => {
  const [isUniqueOpen, setIsUniqueOpen] = useState(false);
  const [isRightbarOpen, setIsRightbarOpen] = useState(false);
  const [allGroups, setAllGroups] = useState([]);
  const [allRdbms, setAllRdbms] = useState([]);

  const { entityUniqueField, setEntityUniqueField, entityInitData, setEntityInitData, selectedEntitySm } =
    useEntityContext();

  const { orgId } = useParams();

  const removeUniqueField = (id) => {
    const copyUniqueFields = JSON.parse(JSON.stringify(entityUniqueField));
    const updatedFields = copyUniqueFields.filter((field) => field !== id);
    setEntityUniqueField(updatedFields);
  };

  const handleMessageChange = (data) => {
    const newActivityData = { ...entityInitData };
    newActivityData.activity_response = data;
    setEntityInitData(newActivityData);
  };

  const handleOwnerAssignment = (owner) => {
    const newEntityInitData = JSON.parse(JSON.stringify(entityInitData));
    newEntityInitData.activity_owner_assignment = owner;
    setEntityInitData(newEntityInitData);
  };

  const selectUniqueFields = (data) => {
    const copyUniqueFields = JSON.parse(JSON.stringify(entityUniqueField));
    if (copyUniqueFields.includes(data.id)) {
      toastError("Duplicate fields not allowed");
      return;
    }
    copyUniqueFields.push(data.id);
    setEntityUniqueField(copyUniqueFields);
  };

  const fetchAllGroups = async () => {
    try {
      const { data } = await axiosInstance.get(`/user-service/groups/org/${orgId}`);
      setAllGroups(data);
    } catch (error) {
      handleApiError(error);
    }
  };

  const fetchAllRdbmsTemplates = async () => {
    try {
      const { data } = await axiosInstance.get(`/rdbms`);
      const groupRdbms = data.filter((rdbms) => rdbms.is_group);
      setAllRdbms(groupRdbms);
    } catch (error) {
      handleApiError(error);
    }
  };

  useEffect(() => {
    fetchAllGroups();
    fetchAllRdbmsTemplates();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="activity-main-screen">
      <div className="entity-job-items">
        <div>
          <div className="activity_select_top_block builder_form my_0 mx_auto w_75">
            <div className="d_flex gap_3">
              <label className="builder_label">Select unique fields </label>
              <ButtonActionIcon type="add" size="xsm" onClick={() => setIsUniqueOpen(true)} />
            </div>
            <div className="selected_chip_container mt_3 mb_4 mx_0">
              {entityUniqueField?.map((field) => (
                <div className="selected_chip_items py_2 px_3" key={field}>
                  {allFieldsObject.current[field]?.display}
                  <MaterialIcon name="close" className="font_size_large" onClick={() => removeUniqueField(field)} />
                </div>
              ))}
            </div>
          </div>
          <div className="owner_assignment_container">
            <div className="position_relative">
              <div className="activity_select_top_block builder_form w_75" style={{ margin: "53px auto 20px auto" }}>
                <label className="section_sub_heading">Owner Assignment</label>
                <div className="form_edit_del_buttons">
                  <button
                    className="builder_action_btn  edit font_size_xlarge"
                    title=""
                    style={{ width: "32px", height: "32px" }}
                    onClick={() => setIsRightbarOpen(true)}
                  >
                    <MaterialIcon name="edit" className="font_size_xlarge" />
                  </button>
                </div>
                <div className="overlay_cover"></div>
                <OwnerAssignmentCard
                  ownerAssignment={entityInitData.activity_owner_assignment}
                  allGroups={allGroups}
                  allRdbms={allRdbms}
                />
              </div>
            </div>
          </div>
          <SuccessError
            data={entityInitData.activity_response}
            onChange={handleMessageChange}
            tableID={selectedEntitySm.stateid}
          />
        </div>
      </div>
      <BuilderModal isOpen={isUniqueOpen} onClose={() => setIsUniqueOpen(false)} modalName="Select Unique Fields">
        <TableTreeModal callbackFunction={selectUniqueFields} tableId={selectedEntitySm.stateid} />
      </BuilderModal>
      <BuilderRightSideBar isOpen={isRightbarOpen} heading="Owner Assignment" onClose={(res) => setIsRightbarOpen(res)}>
        <OwnerAssignment
          ownerAssignment={entityInitData.activity_owner_assignment}
          setOwnerAssignment={handleOwnerAssignment}
        />
      </BuilderRightSideBar>
    </div>
  );
};

export default EntitySettings;
